<template>
	<div>
		<div v-if="isErrorOnLoad" class="notification is-danger is-light">
			{{ message }}
		</div>
		<div v-if="isActive">
			<div class="content">
				<h1 class="title is-bold">Reset password</h1>
			</div>
			<form-reset-password
				:fetching="fetching"
				:message="message"
				:message-type="messageType"
				@submit="complete"
			></form-reset-password>
		</div>

		<div v-if="isSuccess" class="content">
			<div class="notification is-success is-light">
				<p>
					{{ message }}
				</p>
			</div>
			<p>Please login.</p>
			<p>
				<router-link class="button is-primary" :to="{ name: 'Login' }"
					>Login</router-link
				>
			</p>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { tokenType } from "../api";
export default {
	name: "AuthResetPassword",
	data() {
		return {
			active: true,
			resetuser: false
		};
	},
	computed: {
		...mapGetters({
			user: "authentication/user",
			fetching: "authentication/fetching",
			message: "authentication/message",
			messageType: "authentication/messageType"
		}),
		details() {
			return {
				userid: this.userid,
				token: this.resettoken,
				type: tokenType.passwordReset
			};
		},
		isActive() {
			return this.resetuser && this.active;
		},
		isErrorOnLoad() {
			return !this.resetuser && this.message;
		},
		isSuccess() {
			return (
				this.resetuser && this.message && this.messageType === "is-success"
			);
		},
		userid() {
			return Number(this.$route.params.userid);
		},
		resettoken() {
			return this.$route.params.resettoken;
		}
	},
	async created() {
		await this.validate(this.details);
		if (this.user) {
			this.resetuser = true;
		}
	},
	methods: {
		...mapActions({
			validate: "authentication/validate",
			setpassword: "authentication/setpassword"
		}),
		async complete({ password }) {
			const data = {
				...this.details,
				password
			};
			await this.setpassword(data);

			this.active = false;
		}
	}
};
</script>
